<template>
  <div>
    <v-btn
      v-if="button.mobileIcon"
      class="d-flex d-sm-none mr-0"
      text
      :loading="button.loading"
      :disabled="button.disabled"
      :color="button.mobileColor"
      :class="button.mobileClass"
      :icon="true"
      @click="button.action"
    >
      <v-icon>{{ button.mobileIcon }}</v-icon>
    </v-btn>
    <v-btn
      :text="button.flat"
      :loading="button.loading"
      :disabled="button.disabled"
      :color="button.color"
      :class="buttonClass(button)"
      :icon="!!button.icon"
      @click="button.action"
    >
      <v-icon v-if="button.icon">
        {{ button.icon }}
      </v-icon>
      {{ button.text }}
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'PageBarButton',
  props: {
    button: Object
  },
  methods: {
    buttonClass (button) {
      const result = {}
      if (button.class) {
        result[button.class] = true
      }
      result['hidden-xs-only'] = !!button.mobileIcon
      return result
    }
  }
}
</script>
